"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManagementGroup = void 0;
var _ManagementGroupType = require("../ServiceTree/ManagementGroupType");
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var ManagementGroup = /*#__PURE__*/function () {
  function ManagementGroup() {
    _classCallCheck(this, ManagementGroup);
  }
  _createClass(ManagementGroup, null, [{
    key: "formatType",
    value:
    /**
     * Adds space in between PascalCased terms
     */
    function formatType(type) {
      var _formattedTypeMap;
      var formattedTypeMap = (_formattedTypeMap = {}, _defineProperty(_formattedTypeMap, _ManagementGroupType.ManagementGroupType.Division, "Division"), _defineProperty(_formattedTypeMap, _ManagementGroupType.ManagementGroupType.Organization, "Organization"), _defineProperty(_formattedTypeMap, _ManagementGroupType.ManagementGroupType.ServiceGroup, "Service Group"), _defineProperty(_formattedTypeMap, _ManagementGroupType.ManagementGroupType.TeamGroup, "Team Group"), _defineProperty(_formattedTypeMap, _ManagementGroupType.ManagementGroupType.Service, "Service"), _defineProperty(_formattedTypeMap, _ManagementGroupType.ManagementGroupType.Unknown, ""), _formattedTypeMap);
      if (type) {
        return formattedTypeMap[type];
      }
      return "";
    }
  }, {
    key: "toParentMap",
    value: function toParentMap(managementGroups) {
      var managementGroupParentMap = {};
      var _iterator = _createForOfIteratorHelper(managementGroups),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var group = _step.value;
          if (group.parentId) {
            if (managementGroupParentMap[group.parentId] === undefined) {
              managementGroupParentMap[group.parentId] = [group];
            } else {
              managementGroupParentMap[group.parentId].push(group);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return managementGroupParentMap;
    }
  }]);
  return ManagementGroup;
}();
exports.ManagementGroup = ManagementGroup;
_defineProperty(ManagementGroup, "sortAlphabetically", function (a, b) {
  var aName = a.name.toLocaleUpperCase();
  var bName = b.name.toLocaleUpperCase();
  if (aName < bName) {
    return -1;
  } else if (aName > bName) {
    return 1;
  } else {
    return 0;
  }
});